




































































import {Component, Watch} from "vue-property-decorator";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import {EmployeeType, ReceiptExpensesPickingListTargetType} from "@/enums/type";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import ReceiptExpensesPickingListTargetTypeLabel
    from "@/modules/receiptsexpenses/shared/components/ReceiptExpensesPickingListTargetTypeLabel/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import ReceiptPaymentTypeLabel from "@/modules/receiptsexpenses/shared/components/ReceiptPaymentType/index.vue";
import {ReceiptExpensePickingListPayStatus} from "@/enums/status";
import ReceiptExpensePickingListPayStatusLabel
    from "@/modules/receiptsexpenses/shared/components/ReceiptExpensePickingListPayStatusLabel/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import debounce from "lodash/debounce";
import ReceiptCustomerPickingListDetail from "@/modules/receiptsexpenses/receiptcustomer/shared/Detail/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import ManageFeeCustomerPayedDetail from "@/modules/managefeecustomer/ListPayed/components/Detail/index.vue";
import {ManageFeeParams} from "@/modules/managefeecustomer/params";
import {ManageFeeStore} from "@/modules/managefeecustomer/store";
import TableToExcel from "@linways/table-to-excel";
import ManageFeePayedCustomerExcel
  from "@/modules/managefeecustomer/ListPayed/components/ManageFeePayedCustomerExcel/index.vue";
import moment from 'moment';
import { FORMAT_DATE_PICKER } from '@/shared/constant';


const columns = [
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "action",
        scopedSlots: {customRender: "action"},
        width: 150,
    },
    {
        title: "Ngày tạo",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 150,
        ellipsis: true
    },
    {
        title: "Mã bảng kê",
        dataIndex: "code",
        key: "code",
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng số đơn",
        dataIndex: "quantityLading",
        key: "quantityLading",
        width: 120,
        ellipsis: true
    },
    {
        title: "Tổng số tiền",
        dataIndex: "totalMoney",
        key: "totalMoney",
        scopedSlots: {customRender: "totalMoney"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Người thu",
        dataIndex: "createdBy.employee.fullname",
        key: "createdByName",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: "createdName"}
    },
    {
        title: "Hình thức thu",
        dataIndex: "paymentType",
        key: "paymentType",
        scopedSlots: {customRender: "paymentType"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "statusPayment",
        key: "statusPayment",
        scopedSlots: {customRender: "statusPayment"},
        width: 150,
        ellipsis: true
    }
];
@Component({
    name: "ManageFeeCustomerPayed",
    components: {
        ManageFeeCustomerPayedDetail,
        TooltipLabel,
        ReceiptCustomerPickingListDetail,
        ReceiptExpensePickingListPayStatusLabel,
        ReceiptPaymentTypeLabel,
        ReceiptExpensesPickingListTargetTypeLabel,
        EmployeeSelector, MillisecondDatePicker,
        ManageFeePayedCustomerExcel
    }
})
export default class extends mixins(CommonMixin) {
    params = new ManageFeeParams();
    moment = moment;
  FORMAT_DATE_PICKER = FORMAT_DATE_PICKER;
  ReceiptExpensesPickingListTargetType = ReceiptExpensesPickingListTargetType;
    ReceiptExpensePickingListPayStatus = ReceiptExpensePickingListPayStatus;
    EmployeeType = EmployeeType;
    columns = columns;
    isExporting = false;

    visibleDetailCustomer = false;
    payedDetailId = null as any;

    created() {
        ManageFeeStore.paramPayedManageFeeChange(this.params);
    }
  async exportExcel() {
    this.isExporting = true;
     await ManageFeeStore.exportExcelPayed(this.params);
    this.isExporting = false;
    setTimeout(() => {
      TableToExcel.convert(document.getElementById("table-excel-payed"), {
        name: `Danh sách đơn.xlsx`,
        sheet: {
          name: "Sheet 1"
        }
      }, 800);
    })
  }
    get pickingLists(): Array<ReceiptExpensePickingList> {
        return ManageFeeStore.payedIds.map(id =>  ManageFeeStore.payedData[id]);
    }

    get pagination() {
        return {
            current: ManageFeeStore.payedMeta.page,
            pageSize: ManageFeeStore.payedMeta.limit,
            total: ManageFeeStore.payedMeta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bảng kê`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        const params = {
            ...ManageFeeStore.payedParams,
            page: pagination.current,
            limit: pagination.pageSize
        }
        ManageFeeStore.paramPayedManageFeeChange(params);
    }

    async seeDetail(pickingList: ReceiptExpensePickingList) {
        const params = {
            ...{},
            revenueExpenditureId: pickingList.id,
            page: 1,
            limit: 50
        };
        await ManageFeeStore.listDebtsDetailPayedManageFee(params);
        this.payedDetailId = pickingList.id;
        this.visibleDetailCustomer = true;
    }

    @Watch("params", {deep: true})
    onParamChange(val: ManageFeeParams) {
        const params = {
            ...val,
            page: 1
        }
        this.handleParamChange(params);
    }

    handleParamChange = debounce((params: any) => {
        ManageFeeStore.paramPayedManageFeeChange(params);
    }, 500)
}
